import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutTableProfile extends Layout {
    sourceProfile: DataSource;
    tableCallRecords: Table;
}
